import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { SidebarContext } from 'app/state/contexts/SidebarContext';
import { TagContext } from 'app/state/contexts/TagContext';
import { IconButton } from 'app/components/ui/IconButton/IconButton';

interface SelectedCell {
  row: number;
  col: number;
  value: string;
  isNumeric: boolean;
}

interface AddTagProps {
  element: {
    children?: object[];
    formatting?: {
      listType: string | null;
      indent: boolean;
    };
    previousRevisionId?: string | null;
    revisionId?: string;
    type: string;
    uuid: string;
    referenceDataSuperId?: string;
  };
  // Table-specific props (optional)
  selectedCells?: SelectedCell[];
  referenceDataSuperId?: string;
  onTagsCreated?: () => void;
}

export const AddTag = ({ element, selectedCells, referenceDataSuperId, onTagsCreated }: AddTagProps) => {
  const { setIsSidebarOpen, setActiveTagsTab } = useContext(SidebarContext);
  const { setDraftTag, setTableTagSelection } = useContext(TagContext) || {};
  const documentPermissions = useSelector((state: any) => state.document.documentPermissions) || [];
  const isTagViewer = documentPermissions.includes('TAG_VIEWER') && !documentPermissions.includes('TAG_EDITOR') && !documentPermissions.includes('TAG_ADMIN');

  if (isTagViewer) {
    return null;
  }

  // Check if this is a table tagging scenario
  const isTableTagging = !!selectedCells?.length;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (isTableTagging) {
      // Table tagging: store selection in context for Footer to use
      if (setTableTagSelection) {
        setTableTagSelection({
          element,
          referenceDataSuperId,
          cells: selectedCells,
          onTagsCreated,
        });
      }
      // Open sidebar to tags tab (index 7) and switch to taxonomy
      setActiveTagsTab('taxonomy');
      setIsSidebarOpen(8);
    } else {
      // Text tagging: store the element ID for the Footer to use
      setDraftTag({ onId: element.uuid });
      // Open sidebar to tags tab (index 7) and switch to taxonomy
      setActiveTagsTab('taxonomy');
      setIsSidebarOpen(8);
    }
  };

  // Disable button if table tagging mode but no cells selected
  const isDisabled = isTableTagging && !selectedCells?.length;

  return <IconButton icon="tag" onMouseDown={handleClick} disabled={isDisabled} />;
};
